const sortLangs = (langs) => {
    return langs
        .sort((a, b) => {
        const pA = (a === null || a === void 0 ? void 0 : a.displayOrder) || 0;
        const pB = (b === null || b === void 0 ? void 0 : b.displayOrder) || 0;
        if (pA > pB)
            return +1;
        if (pA < pB)
            return -1;
        return 0;
    })
        .map((l) => {
        if (typeof l === "string")
            return l;
        return l.id;
    });
};
const normalizeEsCatalogs = (res) => {
    try {
        return res.map((r) => {
            const { displayName, displayOrder, languages, fallback } = r.data;
            const data = {
                id: r.id,
                displayOrder,
                displayName,
                fallback,
                languages: sortLangs(!!languages.length ? languages : [{ displayOrder: 1, id: fallback }]),
                languagesTag: languages.reduce((acc, lang) => {
                    if (!lang.languageTag)
                        return acc;
                    acc[lang.id] = lang.languageTag || "";
                    return acc;
                }, {}),
            };
            return data;
        });
    }
    catch {
        return [];
    }
};
export default normalizeEsCatalogs;
